import { UserAgent } from '@quentin-sommer/react-useragent';
import React from 'react';
import ContentLoader from 'react-content-loader';
import styles from './my-bookings-loader.module.scss';

const MyBookingsLoader: React.FC = props => {
  return (
    <div className={styles.root}>
      <UserAgent computer>
        <ContentLoader
          uniqueKey="my-bookings-loading"
          viewBox="0 0 1128 800"
          height={800}
          width={1128}
          speed={2}
          {...props}
          backgroundColor="var(--color-background)"
        >
          <rect x="0" y="0" rx="14" ry="14" width="304" height="188" />
          <rect x="320" y="12" rx="14" ry="14" width="314" height="20" />
          <rect x="320" y="52" rx="14" ry="14" width="493" height="16" />
          <rect x="320" y="112" rx="14" ry="14" width="263" height="16" />
          <rect x="320" y="148" rx="14" ry="14" width="700" height="16" />

          <rect x="0" y="212" rx="14" ry="14" width="304" height="188" />
          <rect x="320" y="224" rx="14" ry="14" width="314" height="20" />
          <rect x="320" y="264" rx="14" ry="14" width="493" height="16" />
          <rect x="320" y="324" rx="14" ry="14" width="263" height="16" />
          <rect x="320" y="360" rx="14" ry="14" width="800" height="16" />

          <rect x="0" y="444" rx="14" ry="14" width="357" height="220" />
          <rect x="0" y="679" rx="14" ry="14" width="241" height="20" />
          <rect x="0" y="719" rx="14" ry="14" width="161" height="16" />
          <rect x="0" y="747" rx="14" ry="14" width="332" height="16" />

          <rect x="0" y="444" rx="14" ry="14" width="357" height="220" />
          <rect x="0" y="679" rx="14" ry="14" width="241" height="20" />
          <rect x="0" y="719" rx="14" ry="14" width="161" height="16" />
          <rect x="0" y="747" rx="14" ry="14" width="332" height="16" />

          <rect x="385" y="444" rx="14" ry="14" width="357" height="220" />
          <rect x="385" y="679" rx="14" ry="14" width="241" height="20" />
          <rect x="385" y="719" rx="14" ry="14" width="161" height="16" />
          <rect x="385" y="747" rx="14" ry="14" width="332" height="16" />

          <rect x="770" y="444" rx="14" ry="14" width="357" height="220" />
          <rect x="770" y="679" rx="14" ry="14" width="241" height="20" />
          <rect x="770" y="719" rx="14" ry="14" width="161" height="16" />
          <rect x="770" y="747" rx="14" ry="14" width="332" height="16" />
        </ContentLoader>
      </UserAgent>
      <UserAgent mobile>
        <ContentLoader
          uniqueKey="my-bookings-loading"
          viewBox="0 0 350 500"
          height={500}
          width={350}
          speed={2}
          {...props}
          backgroundColor="var(--color-background)"
        >
          <rect x="0" y="16" rx="14" ry="14" width="120" height="18" />

          <rect x="0" y="56" rx="14" ry="14" width="340" height="200" />
          <rect x="0" y="270" rx="14" ry="14" width="280" height="16" />
          <rect x="0" y="310" rx="14" ry="14" width="260" height="16" />
          <rect x="0" y="340" rx="14" ry="14" width="180" height="16" />
          <rect x="0" y="370" rx="14" ry="14" width="300" height="16" />
          <rect x="0" y="410" rx="14" ry="14" width="100" height="16" />
          <rect x="0" y="440" rx="14" ry="14" width="180" height="16" />
          <rect x="0" y="470" rx="14" ry="14" width="220" height="16" />
        </ContentLoader>
      </UserAgent>
    </div>
  );
};

export default MyBookingsLoader;
